import {
  SETENGLISHPOSITIVERESPONSE,
  SETENGLISHNEGATIVERESPONSE,
  SETSPANISHPOSITIVERESPONSE,
  SETSPANISHNEGATIVERESPONSE,
} from './actionType'

export function setEnglishPositiveResponse(data) {
  return {
    type: SETENGLISHPOSITIVERESPONSE,
    data: data,
  }
}
export function setEnglishNegativeResponse(data) {
  return {
    type: SETENGLISHNEGATIVERESPONSE,
    data: data,
  }
}
export function setSpanishPositiveResponse(data) {
  return {
    type: SETSPANISHPOSITIVERESPONSE,
    data: data,
  }
}
export function setSpanishNegativeResponse(data) {
  return {
    type: SETSPANISHNEGATIVERESPONSE,
    data: data,
  }
}
